import { render } from "./InputRadio.vue?vue&type=template&id=2c778215"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__